import request from "@/utils/request";

// 查询物流信息
export function getLocusList(params) {
  return request({
    url: '/trade/return-delivery/queryExpress',
    method: 'get',
    params
  })
}
// 获取所有物流公司列表
export function getLogisticsList() {
  return request({
    url: '/setting/logistics/list',
    method: 'get',
  })
}
// 填写物流信息
export function addLogistics(data) {
  return request({
    url: '/trade/return-delivery/addDelivery',
    method: 'post',
    data
  })
}
// 取消退货退款
export function cancelAfterSale(params) {
  return request({
    url: '/trade/sales-return/h5/cancel',
    method: 'get',
    params
  })
}
// 获取售后列表
export function AfterSaleList(params) {
  return request({
    url: '/trade/sales-return/customer/page',
    method: 'get',
    params
  })
}
// 查询退单详情
export function getAfterSaleDetail(params) {
  return request({
    url: '/trade/sales-return/h5/detail',
    method: 'get',
    params
  })
}
// 查询退单自动确认收货时间
export function getAutoConfirmTime(data) {
  return request({
    url: '/trade/sales-return/time/left',
    method: 'post',
    data
  })
}

// 获取分销商售后订单列表
export function StoreAfterSaleList(params) {
  return request({
    url: '/trade/sales-return/h5/retailer/page',
    method: 'get',
    params
  })
}